import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SeoHead from '@/components/feature/SeoHead';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://www.diariode1trader.com';

const sobreSchema = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: 'Sobre | Diário de 1 Trader',
  url: `${siteUrl}/sobre`,
  description: 'Conheça a equipa da Diário de 1 Trader — traders com anos de experiência dedicados a ajudar traders portugueses a navegar no mundo das prop firms e do trading de futuros.',
  publisher: {
    '@type': 'Organization',
    name: 'Diário de 1 Trader',
    url: siteUrl,
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'info@diariode1trader.com',
      contactType: 'customer support',
    },
    sameAs: ['https://www.youtube.com/@diario1trader'],
  },
};

export default function SobrePage() {
  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="Sobre a Diário de 1 Trader | Quem Somos e a Nossa Missão"
        description="Conheça a Diário de 1 Trader — traders experientes dedicados a ajudar traders portugueses a escolher prop firms, aprender estratégias e evitar erros comuns no trading de futuros."
        keywords="sobre diário de 1 trader, quem somos, missão, trading futuros portugal"
        canonical="/sobre"
        schema={sobreSchema}
      />
      <Navbar />
      <div className="pt-28 pb-20">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-700 text-xs font-semibold px-4 py-2 rounded-full mb-4">
              <i className="ri-team-line"></i>
              Quem Somos
            </div>
            <h1 className="text-3xl md:text-5xl font-extrabold text-[#0d1f3c] mb-4">Sobre a FuturosPro</h1>
            <p className="text-slate-500 max-w-2xl mx-auto text-lg">Transparência, experiência e dedicação ao trader português.</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
            <div className="rounded-2xl overflow-hidden h-80 lg:h-auto">
              <img
                src="https://public.readdy.ai/ai/img_res/0f245c422cb6598526b38c73bb411134.jpg"
                alt="Equipa FuturosPro"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div>
              <h2 className="text-2xl md:text-3xl font-extrabold text-[#0d1f3c] mb-6">A Nossa Missão</h2>
              <p className="text-slate-600 leading-relaxed mb-4">
                A FuturosPro nasceu da necessidade de ter um recurso em português de Portugal completamente dedicado ao trading de futuros em prop firms. Somos traders com anos de experiência que decidiram partilhar conhecimento de forma transparente e imparcial.
              </p>
              <p className="text-slate-600 leading-relaxed mb-6">
                O nosso objetivo é simples: ajudar traders portugueses a escolher a melhor prop firm, aprender estratégias comprovadas e evitar os erros mais comuns que levam à perda de contas financiadas.
              </p>
              <div className="grid grid-cols-3 gap-4">
                {[
                  { value: '6+', label: 'Anos de Experiência' },
                  { value: '500+', label: 'Traders Ajudados' },
                  { value: '95%', label: 'Satisfação' },
                ].map((stat) => (
                  <div key={stat.label} className="bg-blue-50 rounded-xl p-4 text-center">
                    <div className="text-2xl font-extrabold text-blue-600">{stat.value}</div>
                    <div className="text-xs text-slate-500 mt-1">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="bg-[#f0f6ff] rounded-2xl p-8 md:p-12 mb-16">
            <h2 className="text-2xl font-extrabold text-[#0d1f3c] mb-8 text-center">Os Nossos Valores</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {[
                { icon: 'ri-shield-check-line', title: 'Transparência Total', desc: 'Divulgamos sempre os nossos links de afiliado. As nossas análises são independentes e baseadas em experiência real.' },
                { icon: 'ri-microscope-line', title: 'Análises Rigorosas', desc: 'Testamos cada prop firm com contas reais antes de publicar qualquer recomendação. Sem publicidade disfarçada.' },
                { icon: 'ri-graduation-cap-line', title: 'Educação Primeiro', desc: 'Acreditamos que um trader educado é um trader de sucesso. Todo o conteúdo educacional é 100% gratuito.' },
              ].map((v) => (
                <div key={v.title} className="text-center">
                  <div className="w-14 h-14 flex items-center justify-center bg-blue-600 rounded-2xl mx-auto mb-4">
                    <i className={`${v.icon} text-white text-2xl`}></i>
                  </div>
                  <h3 className="font-bold text-[#0d1f3c] mb-2">{v.title}</h3>
                  <p className="text-slate-500 text-sm leading-relaxed">{v.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-blue-600 rounded-2xl p-8 text-center text-white">
            <h2 className="text-2xl font-bold mb-3">Disclosure de Afiliados</h2>
            <p className="text-blue-100 max-w-3xl mx-auto text-sm leading-relaxed">
              A FuturosPro é um site de marketing de afiliados. Quando clica nos nossos links e se regista numa prop firm, podemos receber uma comissão. Isso não tem qualquer custo adicional para si e não influencia as nossas análises. Somos completamente transparentes sobre esta relação comercial.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
